"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAIR_ROW_HEIGHT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const react_window_1 = require("react-window");
const LeftArrowIcon_1 = __importDefault(require("src/icons/LeftArrowIcon"));
const SearchIcon_1 = __importDefault(require("src/icons/SearchIcon"));
const constants_1 = require("src/misc/constants");
const accounts_1 = require("../contexts/accounts");
const FormPairRow_1 = __importDefault(require("./FormPairRow"));
const USDValueProvider_1 = require("src/contexts/USDValueProvider");
const decimal_js_1 = __importDefault(require("decimal.js"));
exports.PAIR_ROW_HEIGHT = 72;
const SEARCH_BOX_HEIGHT = 56;
// eslint-disable-next-line react/display-name
const rowRenderer = (0, react_1.memo)((props) => {
    const { data, index, style } = props;
    const item = data.searchResult[index];
    return (0, jsx_runtime_1.jsx)(FormPairRow_1.default, { item: item, style: style, onSubmit: data.onSubmit }, item.address);
}, react_window_1.areEqual);
const FormPairSelector = ({ onSubmit, tokenInfos, onClose, }) => {
    const { accounts } = (0, accounts_1.useAccounts)();
    const { tokenPriceMap } = (0, USDValueProvider_1.useUSDValueProvider)();
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const [searchResult, setSearchResult] = (0, react_1.useState)(tokenInfos);
    (0, react_1.useEffect)(() => {
        const sortedList = tokenInfos
            .sort((a, b) => {
            return constants_1.PAIR_SELECTOR_TOP_TOKENS.includes(a.address) && !constants_1.PAIR_SELECTOR_TOP_TOKENS.includes(b.address) ? -1 : 1;
        })
            .sort((a, b) => {
            var _a, _b;
            if (!accounts[a.address])
                return 1;
            if (!accounts[b.address])
                return -1;
            const [tokenAPrice, tokenBPrice] = [
                (_a = tokenPriceMap[a.address]) === null || _a === void 0 ? void 0 : _a.usd,
                (_b = tokenPriceMap[b.address]) === null || _b === void 0 ? void 0 : _b.usd,
            ];
            // Sort by USD value
            if (tokenAPrice && tokenBPrice) {
                const totalAValue = new decimal_js_1.default(tokenAPrice).mul(accounts[a.address].balance);
                const totalBValue = new decimal_js_1.default(tokenBPrice).mul(accounts[b.address].balance);
                return totalBValue.gt(totalAValue) ? 1 : -1;
            }
            // If no usd value, sort by balance
            return accounts[b.address].balance - accounts[a.address].balance;
        });
        if (searchTerm) {
            const filteredList = sortedList.filter((item) => item.symbol.toLowerCase().includes(searchTerm.toLowerCase()) || item.address.toLowerCase().includes(searchTerm.toLowerCase()));
            setSearchResult(filteredList);
        }
        else {
            setSearchResult(sortedList);
        }
    }, [accounts, tokenInfos, searchTerm]);
    const listRef = (0, react_1.createRef)();
    const inputRef = (0, react_1.createRef)();
    (0, react_1.useEffect)(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, [inputRef]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col h-full w-full py-4 px-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex w-full justify-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-white fill-current w-6 h-6 cursor-pointer", onClick: onClose, children: (0, jsx_runtime_1.jsx)(LeftArrowIcon_1.default, { width: 24, height: 24 }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-white", children: "Select Token" }), (0, jsx_runtime_1.jsx)("div", { className: " w-6 h-6" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex px-5 mt-4 w-[98%] rounded-xl bg-[#212128]", style: { height: SEARCH_BOX_HEIGHT, maxHeight: SEARCH_BOX_HEIGHT }, children: [(0, jsx_runtime_1.jsx)(SearchIcon_1.default, {}), (0, jsx_runtime_1.jsx)("input", { autoComplete: "off", className: "w-full rounded-xl ml-4 truncate bg-[#212128] text-white/50 placeholder:text-white/20", placeholder: `Search`, value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), ref: inputRef })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-2", style: { flexGrow: 1 }, children: [searchResult.length > 0 && ((0, jsx_runtime_1.jsx)(react_virtualized_auto_sizer_1.default, { children: ({ height, width }) => {
                            return ((0, jsx_runtime_1.jsx)(react_window_1.FixedSizeList, { ref: listRef, height: height, itemCount: searchResult.length, itemSize: exports.PAIR_ROW_HEIGHT, width: width - 2, itemData: {
                                    searchResult,
                                    onSubmit,
                                }, className: (0, classnames_1.default)('overflow-y-scroll mr-1 min-h-[12rem] px-5 webkit-scrollbar'), children: rowRenderer }));
                        } })), searchResult.length === 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "mt-4 mb-4 text-center text-white/50", children: (0, jsx_runtime_1.jsx)("span", { children: "No tokens found" }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })] }));
};
exports.default = FormPairSelector;
